/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_content_delivery_bucket": "app.inventoryshark.io-prod",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://d3h2bn7go08436.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-west-2:598814a4-97a0-4f35-84ec-565d74614195",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_82uCjTNop",
    "aws_user_pools_web_client_id": "1p92ub8uqvv6c3mpc37emeamj3",
    "oauth": {
        "domain": "inventoryshark-prod.auth.us-west-2.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app.inventoryshark.io/",
        "redirectSignOut": "https://app.inventoryshark.io/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE",
        "AMAZON"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "LambdaAPIUser",
            "endpoint": "https://2fe0r5cbcd.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        },
        {
            "name": "PublicAPI",
            "endpoint": "https://hvjmpip2wj.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://iksbxr4cxbeyrdunj4f6m7ktz4.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_mobile_analytics_app_id": "7e935614b8df4ba6ad5052e95c261504",
    "aws_mobile_analytics_app_region": "us-west-2"
};


export default awsmobile;
